<template>
  <div class="text-center">
    <h1>
      <v-icon large class="mr-2">
        mdi-cloud-question
      </v-icon>
      {{ $t('message.alert.notfound.title') }}
    </h1>
    <p class="mt-3">
      {{ $t('message.alert.notfound.text') }}
    </p>
    <v-btn small :to="'dashboard'" color="primary" outlined>
      {{ $t('message.alert.notfound.button') }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "notfound"
}
</script>